import '../css/app.css'
import 'flatpickr/dist/flatpickr.min.css';
import CookiesEuBanner from "cookies-eu-banner";
import flatpickr from "flatpickr";
import { Dutch } from "flatpickr/dist/l10n/nl.js";
import { French } from "flatpickr/dist/l10n/fr.js";
import { German } from "flatpickr/dist/l10n/de.js";

// responsive main nav
(function () {

  const navEl = document.querySelector('.small-only .header-nav');
  const toggleEl = document.querySelector('.navigation__toggle');
  const labelEl = toggleEl.querySelector('span');
  const openLabelText = labelEl.innerText;
  const closeLabelText = labelEl.closest('[data-close-label]').dataset.closeLabel;

  toggleEl.addEventListener('click', () => {
    if(!isOpen()) {
      open();
    } else {
      close();
    }
  });

  document.addEventListener('keydown', e => {

    if (!isOpen()) {
      return;
    }

    if (e.key === 'Escape') {
      close();
    }

  });

  function open() {
    navEl.style.display = 'block';
    toggleEl.setAttribute('aria-expanded', 'true');
    labelEl.innerText = closeLabelText;
  }

  function close() {
    navEl.style.display = 'none';
    toggleEl.setAttribute('aria-expanded', 'false');
    toggleEl.focus();
    labelEl.innerText = openLabelText;
  }

  function isOpen() {
    return navEl.style.display !== 'none';
  }

})();

// responsive programme nav
(function () {

  const sidebarEl = document.querySelector('.programme-sidebar');
  if (!sidebarEl) {
    return;
  }
  const toggleEl = document.querySelector('.programme-sidebar__toggle');
  const labelEl = toggleEl.querySelector('span');
  const openLabelText = labelEl.innerText;
  const closeLabelText = labelEl.closest('[data-close-label]').dataset.closeLabel;

  toggleEl.addEventListener('click', () => {
    if(!isOpen()) {
      open();
    } else {
      close();
    }
  });

  document.addEventListener('keydown', e => {

    if (!isOpen()) {
      return;
    }

    if (e.key === 'Escape') {
      close();
    }

  });

  function open() {
    sidebarEl.style.display = 'block';
    toggleEl.setAttribute('aria-expanded', 'true');
    labelEl.innerText = closeLabelText;
  }

  function close() {
    sidebarEl.style.display = 'none';
    toggleEl.setAttribute('aria-expanded', 'false');
    toggleEl.focus();
    labelEl.innerText = openLabelText;
  }

  function isOpen() {
    return window.getComputedStyle(sidebarEl).display !== 'none';
  }

})();

// calendar
(function () {

  const calendarWrapperEl = document.querySelector('.calendar-wrapper');

  if (!calendarWrapperEl) {
    return;
  }

  const now = new Date();
  const getParams = new URLSearchParams(location.search);
  if (getParams.has('maand')) {
    now.setMonth(getParams.get('maand') - 1);
  }
  if (getParams.has('jaar')) {
    now.setFullYear(getParams.get('jaar'));
  }

  calendarWrapperEl.addEventListener('click', async e => {

    const prevEl = e.target.closest('a.prev');
    const nextEl = e.target.closest('a.next');

    if (!prevEl && !nextEl) {
      return;
    }

    let step = 1;
    if (prevEl) {
      step = -1;
    }

    e.preventDefault();

    now.setMonth(now.getMonth() + step);
    const firstDayOfCurrentMonth = new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1);
    if (now < firstDayOfCurrentMonth) {
      return;
    }

    const opts = new URLSearchParams(window.location.search);
    opts.set('maand', now.getMonth() + 1);
    opts.set('jaar', now.getFullYear());
    let url = '/';
    if (calendarWrapperEl.classList.contains('calendar-event-sessions')) {
      url += 'programme';
    } else if (calendarWrapperEl.classList.contains('calendar-ext-events')) {
      url += 'ext-events';
    } else if (calendarWrapperEl.classList.contains('calendar-sch-events')) {
      url += 'sch-events';
    }
    url += '/calendar/html?' + opts.toString();
    const response = await fetch(url);
    const html = await response.text();
    calendarWrapperEl.innerHTML = html;

  });

})();

// newsletter subscribe form
(function () {

  const formEl = document.querySelector('.footer-newsletter__form');
  if (!formEl) {
    return;
  }

  const msgEl = document.querySelector('.footer-newsletter__message');

  formEl.addEventListener('submit', async e => {

    e.preventDefault();

    msgEl.innerHTML = formEl.dataset.loadingMsg;
    msgEl.classList.remove('error');

    const email = formEl.querySelector('[type="email"]').value;

    const url = formEl.dataset.url;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
      }),
    });
    const data = await response.json();
    msgEl.innerHTML = data.message;
    if (data.isError) {
      msgEl.classList.add('error');
    }

  });

})();

// prepend http:// in <input type="url"> if missing
(function () {

  document.addEventListener('change', e => {
    const el = e.target;
    if (el.tagName.toLowerCase() !== 'input') {
      return;
    }
    if (el.type !== 'url') {
      return;
    }
    if (!el.value) {
      return;
    }
    if (!el.value.startsWith('http://') && !el.value.startsWith('https://')) {
      el.value = 'http://' + el.value;
    }
  });

})();

// ext event form
(function () {

  const formEl = document.querySelector('.submit-ext-event');
  if (!formEl) {
    return;
  }

  const imageEl = formEl.querySelector('[name="image"]');
  const removeImageBtnEl = formEl.querySelector('.remove-image');

  const dateRowEl = formEl.querySelector('.date-row').cloneNode(true);

  initFlatpickr();
  applyFlatpickr(formEl.querySelector('.date-row'));

  formEl.addEventListener('change', e => {
    if (e.target.name !== 'organizer_id' && e.target.name !== 'organizer_other') {
      return;
    }
    checkOrganizer();
  });
  checkOrganizer();

  formEl.addEventListener('change', e => {
    if (e.target.name !== 'image') {
      return;
    }
    checkImage();
  });
  checkImage();

  formEl.addEventListener('click', e => {

    const btnEl = e.target;

    if (btnEl.classList.contains('add-date')) {
      addDate();
    }

    if (btnEl.classList.contains('remove-date')) {
      const rowEl = btnEl.closest('.date-row');
      console.log(rowEl);
      rowEl.remove();
    }

  });

  removeImageBtnEl.addEventListener('click', () => {
    imageEl.value = '';
    checkImage();
  });

  formEl.addEventListener('change', e => {
    if (!['location_id', 'street', 'zip', 'city'].includes(e.target.name)) {
      return;
    }
    checkLocation();
  });
  checkLocation();

  function checkOrganizer() {
    const organizerIdEl = formEl.querySelector('[name="organizer_id"]');
    const organizerOtherEl = formEl.querySelector('[name="organizer_other"]');
    let required = !organizerIdEl.value.trim() && !organizerOtherEl.value.trim();
    organizerIdEl.required = required;
    organizerOtherEl.required = required;
  }

  function addDate() {
    const newRowEl = dateRowEl.cloneNode(true);
    newRowEl.querySelector('[name="dates_start[]"]').value = '';
    newRowEl.querySelector('[name="dates_end[]"]').value = '';
    newRowEl.querySelector('.remove-date').style.display = '';
    const origRowEl = formEl.querySelector('.date-row');
    origRowEl.parentNode.insertBefore(newRowEl, origRowEl.nextSibling);
    applyFlatpickr(newRowEl);
  }

  function checkImage() {

    const previewEl = formEl.querySelector('.image-preview');
    previewEl.style.display = 'none';
    previewEl.src = '';

    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;

    let file = null;

    if (imageEl.files && imageEl.files[0] && !allowedExtensions.exec(imageEl.files[0].name)) {
      imageEl.value = '';
      return;
    }

    if (imageEl.files && imageEl.files[0] && imageEl.files[0].size > 5242880) {
      imageEl.value = '';
      return;
    }

    if (imageEl.files && imageEl.files[0]) {

      removeImageBtnEl.style.display = '';

      const reader = new FileReader();
      reader.onload = e => {
        previewEl.style.display = '';
        previewEl.src = e.target.result;
      };
      reader.readAsDataURL(imageEl.files[0]);

    } else {

      removeImageBtnEl.style.display = 'none';

    }

  }

  function initFlatpickr() {
    let lang = 'nl';
    const path = window.location.pathname;
    if (path.length > 0) {
      lang = path.substr(1, 2);
    }
    flatpickr.localize(flatpickr.l10ns[lang]);
  }

  function applyFlatpickr(wrapperEl) {
    const els = wrapperEl.querySelectorAll('[name="dates_start[]"],[name="dates_end[]"]');
    flatpickr(els, {
      allowInput: true,
      defaultHour: 19,
      enableTime: true,
      time_24hr: true,
      dateFormat: 'd/m/Y H:i',
      minDate: 'today',
    });
  }

  function checkLocation() {
    const locIdEl = formEl.querySelector('[name="location_id"]');
    const streetEl = formEl.querySelector('[name="street"]');
    const zipEl = formEl.querySelector('[name="zip"]');
    const cityEl = formEl.querySelector('[name="city"]');
    let required = true;
    if (locIdEl.value.trim()) {
      required = false;
    } else if (streetEl.value.trim() &&
      zipEl.value.trim() &&
      cityEl.value.trim()) {
      required = false;
    }
    locIdEl.required = required;
    streetEl.required = required;
    zipEl.required = required;
    cityEl.required = required;
  }

})();

// tixly
(function () {

  const tixlyBasketIframeEl = document.getElementById('tixly-basket');
  if (!tixlyBasketIframeEl) {
    return;
  }
  tixlyBasketIframeEl.addEventListener('load', () => {
    window.addEventListener('message', e => {
      // console.log(e.origin, window.TIXLY_URL, e.data);
      if (e.origin !== window.TIXLY_URL) {
        return;
      }
      let numItemsText = '';
      if(e.data && e.data.order && e.data.order.items.length){
        numItemsText = e.data.order.items.length;
      }
      const numItemsEls = document.querySelectorAll('.tixly-basket-num-items');
      numItemsEls.forEach((numItemsEl) => {
        numItemsEl.innerText = numItemsText;
      });
      if (parseInt(numItemsText) > 0) {
        const basketLinkEls = document.querySelectorAll('.t-icon-basket');
        basketLinkEls.forEach((basketLinkEl) => {
          basketLinkEl.href = basketLinkEl.dataset.tixlyBasketUrl;
        });
      }
    });
    const iframeWindowEl = tixlyBasketIframeEl.contentWindow;
    iframeWindowEl.postMessage('GetSession', window.TIXLY_URL);
  });

})();


// cookie banner
window.addEventListener('DOMContentLoaded', () => {
  new CookiesEuBanner(function () {

    // Matomo
    const env = document.documentElement.dataset.siteEnv;
    if (env !== 'prod') {
      return;
    }
    const siteId = document.documentElement.dataset.matomoSiteId;
    if (!siteId) {
      return;
    }
    const _paq = window._paq = window._paq || [];
    _paq.push(['setDoNotTrack', true]);
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function () {
      const u = "https://derand.matomo.cloud/";
      _paq.push(['setTrackerUrl', u + 'matomo.php']);
      _paq.push(['setSiteId', siteId]);
      const d = document, g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = '//cdn.matomo.cloud/derand.matomo.cloud/matomo.js';
      s.parentNode.insertBefore(g, s);
    })();

  }, true);
});
